export const DISPLAY_FORMAT = 'll';
export const ISO_MONTH_FORMAT = 'YYYY-MM';
export const ISO_DATE = 'YYYY-MM-DD';
export const ISO_DATETIME = 'YYYY-MM-DD HH:mm';
export const ISO_DATETIME_SECONDS = 'YYYY-MM-DD HH:mm:ss';
export const ISO_DATETIME_UTC_OFFSET = 'YYYY-MM-DD HH:mm Z';
